<template>
    <button class="open-nav" @click="toggle">
        <slot></slot>
    </button>
</template>

<script>
    export default {
        methods: {
            toggle() {
                this.$root.$data.showNav = !this.$root.$data.showNav
            }
        }
    }
</script>

<style scoped>

</style>